<template>
  <v-container>
    <v-row>
      <v-col lg="8">
        <div class="text-h6 font-weight-bold">Nombre del personal</div>
      </v-col>
      <v-col lg="4">
        <v-row>
          <v-col cols="12">
            <v-form v-model="nameForm" ref="name">
              <BaseInput
                :value="personal.apaterno"
                @input="personal.apaterno = $event"
                :rules="required"
              >
                <template #label> Apellido paterno <span class="red--text">*</span> </template>
              </BaseInput>
              <BaseInput
                v-model="personal.amaterno"
                @input="personal.amaterno = $event"
                :rules="required"
              >
                <template #label>Apellido materno <span class="red--text">*</span> </template>
              </BaseInput>
              <BaseInput
                v-model="personal.nombre"
                @input="personal.nombre = $event"
                :rules="required"
              >
                <template #label>Nombre <span class="red--text">*</span> </template>
              </BaseInput>
              <BaseInput
                v-model="personal.segundoNombre"
                label="Segundo nombre"
              ></BaseInput>
            </v-form>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12">
        <v-divider></v-divider>
      </v-col>
      <v-col lg="8">
        <div class="text-h6 font-weight-bold">Fecha de nacimiento</div>
      </v-col>
      <v-col lg="4">
        <v-row>
          <v-col cols="12">
            <v-form v-model="fechaNacimientoForm" ref="nacimiento">
              <BaseInput
                v-model="personal.fechaNacimiento"
                v-mask="'##/##/####'"
                :rules="dateRules"
                hint="Formato de fecha: DD/MM/YYYY"
              >
                <template #label>Fecha de nacimiento</template>
              </BaseInput>
            </v-form>
          </v-col>
          <v-col cols="12">
            <BaseInput :value="getAge(personal.fechaNacimiento)" readonly>
              <template #label>Edad</template>
            </BaseInput>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12">
        <v-divider></v-divider>
      </v-col>
      <v-col lg="8">
        <div class="text-h6 font-weight-bold">Estado civil</div>
      </v-col>
      <v-col lg="4">
        <v-row>
          <v-col cols="12">
            <v-form v-model="estadoCivilForm" ref="civil">
              <BaseSelect
                v-model="personal.fk_idEstadoCivil"
                :items="estadoCivil"
              >
                <template #label> Estado civil </template>
              </BaseSelect>
            </v-form>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12">
        <v-divider></v-divider>
      </v-col>
      <v-col lg="8">
        <div class="text-h6 font-weight-bold">Sexo</div>
      </v-col>
      <v-col lg="4">
        <v-row>
          <v-col cols="12">
            <v-form v-model="sexoForm" ref="sexo">
              <BaseSelect
                v-model="personal.fk_idSexo"
                :items="sexo"
              >
                <template #label>Sexo</template>
              </BaseSelect>
            </v-form>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12">
        <v-divider></v-divider>
      </v-col>
      <v-col lg="8">
        <div class="text-h6 font-weight-bold">Grupo sanguíneo</div>
      </v-col>
      <v-col lg="4">
        <v-row>
          <v-col cols="12">
            <v-form v-model="grupoSanguineoForm" ref="sanguineo">
              <BaseSelect
                v-model="personal.fk_idCatGrupoSanguineo"
                :items="grupoSanguineo"
              >
                <template #label>Grupo sanguíneo</template>
              </BaseSelect>
            </v-form>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12">
        <v-divider></v-divider>
      </v-col>
      <v-col lg="8">
        <div class="text-h6 font-weight-bold">Habilidades</div>
      </v-col>
      <v-col lg="4">
        <v-row>
          <v-col cols="12">
            <v-combobox
              v-model="habilidadesSeleccionadas"
              :items="habilidadesDisponibles"
              :search-input.sync="busquedaHabilidad"
              :readonly="!canEditHabilidades"
              :deletable-chips="canEditHabilidades"
              :hint="
                canEditHabilidades ? 'Selecciona una habilidad del catálogo o escribe una nueva y presiona enter' : ''
              "
              :persistent-hint="canEditHabilidades"
              multiple
              chips
              small-chips
              hide-selected
              hide-no-data
              rounded
              filled
              dense
              background-color="primary"
              color="secondary"
              item-color="secondary"
              @keydown.enter.prevent="agregarHabilidadPersonalizada"
              @keydown.tab="agregarHabilidadPersonalizada"
            >
              <template #label>Habilidades</template>
            </v-combobox>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import BaseInput from '../../../base/BaseInput.vue'
import BaseSelect from '../../../base/BaseSelect.vue'
import { PERFILES } from '@/perfiles.js'

export default {
  components: {
    BaseInput,
    BaseSelect,
  },
  data() {
    return {
      PERFILES,
      nameForm: false,
      fechaNacimientoForm: false,
      estadoCivilForm: false,
      sexoForm: false,
      grupoSanguineoForm: false,
      busquedaHabilidad: '',
      required: [(v) => !!v || 'Este campo es obligatorio'],
      requiredSelect: [(v) => !!v || 'Este campo es obligatorio'],
      dateRules: [
        (v) => !v || /^\d{2}\/\d{2}\/\d{4}$/.test(v) || 'El formato de fecha debe ser DD/MM/YYYY',
      ],
    }
  },
  computed: {
    ...mapGetters('personal', {
      personal: 'getPersonalSingle',
    }),
    ...mapGetters({
      perfil: 'getPerfil',
    }),
    ...mapGetters('estadoCivil', {
      estadoCivil: 'getEstadoCivil',
    }),
    ...mapGetters('sexo', {
      sexo: 'getSexo',
    }),
    ...mapGetters('grupoSanguineo', {
      grupoSanguineo: 'getGrupoSanguineo',
    }),
    ...mapGetters('habilidades', {
      catalogoHabilidades: 'getHabilidades',
    }),
    canEditHabilidades() {
      return [PERFILES['ADMINSITRADOR GENERAL'], PERFILES.RH_ADMINISTRADOR, PERFILES.REP_ADMINISTRADOR].includes(
        this.perfil
      )
    },
    habilidadesDisponibles() {
      const catalogo = [
        'Antibombas',
        'Antimotín',
        'Bases de datos policiales',
        'Bodycams y evidencia digital',
        'Ciberseguridad básica',
        'Conducción táctica',
        'Denuncia ciudadana digital',
        'Extracción de datos de celulares',
        'Facilidad de palabra',
        'Geolocalización GPS',
        'Georreferenciación de incidentes',
        'Inglés policial técnico',
        'Informes policiales',
        'Inteligencia en redes sociales',
        'Intervención en violencia doméstica',
        'Lenguaje corporal',
        'Manejo de drones',
        'Manejo de estrés en combate',
        'Manejo de perros (canino)',
        'Mediación comunitaria',
        'Perfilamiento de conductas',
        'Primeros auxilios tácticos',
        'Proactivo',
        'Protección a personas',
        'Radios digitales cifradas',
        'Registro de inmuebles',
        'Sistemas de mando y control (C4)',
        'Supervivencia en alto riesgo',
        'Tiro de precisión',
        'Toma de rehenes',
        'Trabajo con MP y peritos',
        'Trabajo en equipo',
        'Uso de fuerza menos letal',
        "Uso de TIC's",
        'Uso de teléfono celular',
        'Videovigilancia (CCTV)',
      ]

      return this.quitarDuplicadosHabilidades([...catalogo, ...this.habilidadesSeleccionadas])
    },
    habilidadesSeleccionadas: {
      get() {
        if (!this.personal || !this.personal.categorizacion) return []

        return this.quitarDuplicadosHabilidades(this.personal.categorizacion.split(/\s*,\s*/))
      },
      set(value) {
        if (!this.personal) return

        const habilidades = Array.isArray(value) ? this.quitarDuplicadosHabilidades(value) : []

        this.personal.categorizacion = habilidades.join(', ')
      },
    },
  },
  methods: {
    ...mapActions('estadoCivil', ['fetchEstadoCivil']),
    ...mapActions('sexo', ['fetchSexo']),
    ...mapActions('grupoSanguineo', ['fetchGrupoSanguineo']),
    ...mapActions('habilidades', ['fetchHabilidades']),
    ...mapActions('personal', ['updatePersonal']),
    normalizarHabilidad(habilidad) {
      if (typeof habilidad === 'string') return habilidad.trim().replace(/\s+/g, ' ')

      if (habilidad && typeof habilidad === 'object') {
        return (habilidad.title || habilidad.nombre || habilidad.descripcion || '').trim().replace(/\s+/g, ' ')
      }

      return ''
    },
    quitarDuplicadosHabilidades(habilidades = []) {
      const habilidadesUnicas = []
      const habilidadesVistas = new Set()

      habilidades.forEach((habilidad) => {
        const habilidadNormalizada = this.normalizarHabilidad(habilidad)
        const llave = habilidadNormalizada.toLowerCase()

        if (!habilidadNormalizada || habilidadesVistas.has(llave)) return

        habilidadesVistas.add(llave)
        habilidadesUnicas.push(habilidadNormalizada)
      })

      return habilidadesUnicas
    },
    agregarHabilidadPersonalizada() {
      if (!this.canEditHabilidades) return

      const nuevaHabilidad = this.normalizarHabilidad(this.busquedaHabilidad)
      if (!nuevaHabilidad) return

      this.habilidadesSeleccionadas = [...this.habilidadesSeleccionadas, nuevaHabilidad]
      this.busquedaHabilidad = ''
    },
    getAge(fechaNacimiento) {
      if (!fechaNacimiento) return ''
      const [dia, mes, anio] = fechaNacimiento.split('/')
      const birthDate = new Date(`${anio}-${mes}-${dia}`)
      const ageDifMs = Date.now() - birthDate.getTime()
      const ageDate = new Date(ageDifMs)
      return Math.abs(ageDate.getUTCFullYear() - 1970)
    },
  },
  async mounted() {
    if (!this.estadoCivil.length) await this.fetchEstadoCivil()
    if (!this.sexo.length) await this.fetchSexo()
    if (!this.grupoSanguineo.length) await this.fetchGrupoSanguineo()
    if (!this.catalogoHabilidades.length) await this.fetchHabilidades()
  },
}
</script>
